import React from 'react';
import { AddressForm } from '../AddressForm';
import { images } from '../../data/images';
export function FinalCta() {
  return <section className="relative overflow-hidden bg-ink" data-id="element-145" data-mp="2ah4jncrgk81q">
      <img src={images.streetDusk} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-146" data-mp="2pewye2p6ksev" />
      <div className="absolute inset-0 bg-ink/60" aria-hidden="true" data-id="element-147" data-mp="2kfk97bau7994" />
      <div className="relative mx-auto max-w-[1440px] px-4 py-24 text-center sm:px-6 lg:px-10 lg:py-36" data-id="element-148" data-mp="2ke96let4o7jl">
        <h2 className="mx-auto max-w-4xl text-4xl font-semibold leading-[1.04] tracking-tightest text-canvas sm:text-5xl lg:text-[60px]" data-id="element-149" data-mp="1wo6jze7zftsd">
          Klaar voor 2027?
          <br className="hidden sm:block" data-id="element-150" data-mp="26hvn60519w2h" /> <span className="text-volt" data-id="element-151" data-mp="21pm2ozmoto7l">Begin met een gratis huisscan.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-lg text-lg text-canvas/80" data-id="element-152" data-mp="21nj5nvn4autd">
          Binnen 60 seconden weet je welke batterij bij je huis past en wat hij je oplevert.
        </p>
        <div className="mx-auto mt-10 max-w-3xl rounded-[24px] bg-canvas p-4 text-left sm:p-5" data-id="element-153" data-mp="190f3dyfesula">
          <AddressForm idPrefix="cta" submitLabel="Start huisscan" data-id="element-154" data-mp="3nbhsffubwu0k" />
        </div>
      </div>
    </section>;
}